import { IModel } from '../base/annotation';

export interface IDSLAdapterDefinition {
    model: IModel;
}

export interface IDSLAdaptation {
    adapterDefintion: IDSLAdapterDefinition;
    adapterConstructor: Function;
}

export class DataFlowDSLAdapterRegistry {
    private static readonly modelToDSLAdapters = new Map<IModel, IDSLAdaptation[]>();

    public static adaptations(model: IModel): IDSLAdaptation[] | undefined {
        return DataFlowDSLAdapterRegistry.modelToDSLAdapters.get(model);
    }

    public static adapter(definition: IDSLAdapterDefinition): ClassDecorator {
        return <TFunction extends Function>(target: TFunction) => {
            DataFlowDSLAdapterRegistry.createAdapter(definition, target);
        };
    }

    public static createAdapter(definition: IDSLAdapterDefinition, target: Function): void {
        const model = definition.model;
        let adaptations = DataFlowDSLAdapterRegistry.modelToDSLAdapters.get(model);
        if (!adaptations) {
            adaptations = [];
            DataFlowDSLAdapterRegistry.modelToDSLAdapters.set(model, adaptations);
        }
        adaptations.push({ adapterDefintion : definition, adapterConstructor: target});
    }
}
